import { SVGProps } from "react";

export function AttributesIcon({
  width = "1em",
  height = "1em",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 512 512"
      fill="none"
      stroke="currentColor"
      strokeWidth={32}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M272 205V160L225 96H50V415H272V300" />
      <path d="M112 160H195M112 205H210M112 255H368M112 300H210M112 350H210" />
      <path d="M368 96H320V415H368" />
      <rect x={368} y={48} width={94} height={94} />
      <rect x={368} y={208} width={94} height={94} />
      <rect x={368} y={368} width={94} height={94} />
    </svg>
  );
}
